
























































































import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class OrderRefundModal extends Vue {
  radios: boolean = true;
  dialog: boolean = true;
  mockData: any[] = [];
  headers: any[] = [];

  created() {
    (this.headers = [
      { text: "Sipariş No", value: "orderNo" },
      { text: "Müşteri", value: "customer" },
      { text: "İade Tarihi", value: "refundDate" },
      { text: "Geri Ödeme Durumu", value: "refundStatus" },
      { text: "Geri Ödenecek", value: "refundTo" },
      { text: "İade Türü", value: "refundType" },
      { text: "Toplam Ücret", value: "TotalPrice" },
    ]),
      (this.mockData = [
        {
          orderNo: "101728",
          customer: "TEST",
          refundDate: "08-12-2020",
          refundStatus: "Beklemede",
          refundTo: "Acente",
          refundType: "Nakit",
          TotalPrice: "80",
        },
      ]);
  }

  data() {
    return {};
  }

  closeDialog() {
    this.$emit("closed");
  }
}
